import React from 'react';
import { Modal } from '../ui/Modal';
import { useUpdateObservation, useObservation } from '../../hooks/api';
import { useModal } from '../../stores/uiStore';
import { ObservationUpdate } from '../../types/api';
import { Spinner } from '../ui/Loading';
import EnhancedObservationForm from './EnhancedObservationForm';

const EditObservationModal: React.FC = () => {
  const modal = useModal('edit-observation');
  const observationId = modal.data?.observationId;
  
  const { data: observation, isLoading: isLoadingObservation } = useObservation(
    observationId,
    modal.isOpen && !!observationId
  );
  
  const updateMutation = useUpdateObservation();
  
  const handleSubmit = async (data: ObservationUpdate) => {
    if (!observationId) return;
    
    try {
      await updateMutation.mutateAsync({
        observationId,
        data,
      });
      modal.close();
    } catch (error) {
      // Error handling is done in the mutation hook
      console.error('Failed to update observation:', error);
    }
  };
  
  const handleCancel = () => {
    if (!updateMutation.isPending) {
      modal.close();
    }
  };
  
  return (
    <Modal
      isOpen={modal.isOpen}
      onClose={handleCancel}
      size="xl"
      closeOnEscape={!updateMutation.isPending}
      closeOnOverlayClick={!updateMutation.isPending}
      showCloseButton={!updateMutation.isPending}
    >
      <div className="p-6">
        {isLoadingObservation ? (
          <div className="flex items-center justify-center py-12">
            <Spinner size="lg" />
          </div>
        ) : observation ? (
          <EnhancedObservationForm
            mode="edit"
            observation={observation}
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            isLoading={updateMutation.isPending}
          />
        ) : (
          <div className="text-center py-12">
            <p className="text-gray-500">Observation not found</p>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default EditObservationModal;
